import { isEmpty } from 'ramda';
import qs from 'query-string';
import {
  GetAccountsCashflowsParams, GetAccountsDocumentsParams, GetAccountsHistoryParams, GetAccountsIbansParams, GetAccountsOrdersParams, GetAccountsOrdersPendingParams, GetAccountsPositionsParams, GetAccountsRatesParams, GetAccountsTradingMarginParams, GetAccountsTwrrParams, GetBondsBondParams, GetBondsCallsParams, GetBondsCouponFormulasParams, GetBondsListParams, GetBondsSameIssuerParams, GetDocumentsParams, GetPersonsAccountsParams, GetSecuritiesQuotesParams, GetSecuritiesSecurityParams,
} from '@goldwasserexchange/actor/rest-services';
import { AccountAvailableCashParams } from '../../accounts';

type Params =
  | AccountAvailableCashParams
  | GetAccountsCashflowsParams
  | Omit<GetAccountsDocumentsParams, 'ROW_NUMBER_START' | 'ROW_NUMBER_END'> & {
    ROW_NUMBER_START?: number | undefined,
    ROW_NUMBER_END?: number | undefined,
  }
  | GetAccountsHistoryParams
  | GetAccountsIbansParams
  | GetAccountsPositionsParams
  | GetAccountsRatesParams
  | GetAccountsTwrrParams
  | GetDocumentsParams
  | GetPersonsAccountsParams
  | GetSecuritiesSecurityParams
  | GetSecuritiesQuotesParams
  | GetAccountsOrdersParams
  | GetAccountsOrdersPendingParams
  | GetAccountsTradingMarginParams
  | GetBondsListParams & { CONNECTED?: number | undefined }
  | GetBondsBondParams & { CONNECTED?: number | undefined }
  | GetBondsSameIssuerParams & { CONNECTED?: number | undefined }
  | GetBondsCallsParams & { CONNECTED?: number | undefined }
  | GetBondsCouponFormulasParams & { CONNECTED?: number | undefined }

export const stringifyParams = (params?: Params) => {
  const stringifiedParams = params && !isEmpty(params) ? `?${qs.stringify(params)}` : '';
  return stringifiedParams;
};
